<template>
  <div class="pt-1 pb-2 pr-1 pl-1">
    <div class="no-gutters mt-1 ml-3 mr-3">
      <div class="row">
        <div class="col-12">
          <div class="parameter-box">
            <h5 v-b-popover.hover.bottom="latitude + ' ' + longitude">{{ position }}</h5>
            <div class="parameter-name">Current position</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4>
              {{ showDigits(speed_over_ground, 1) }} <small>kn</small>
            </h4>
            <div class="parameter-name">Speed over ground</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4>
              {{ showDigits(course_over_ground, 1) }}<small>°</small>
              <font-awesome-icon :icon="['fas', 'location-arrow']" size="xs" class="text-info ml-2" :style="{ transform: rotateArrow(heading) }" />
            </h4>
            <div class="parameter-name">Course over ground</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span class="ml-2 dashboard-group-header">Scientific data:</span>
        </div>
        <div class="col">
          <hr class="mr-2 dashboard-group-header-hr">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="water_temperature !== 0">
              <a href="#" class="parameter-link" @click="selectParameter(102, 1)" title="Show water temperature in chart and map">{{ showDigits(water_temperature, 1) }}</a> <small>°C</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Water temperature</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="salinity !== 0">
              <a href="#" class="parameter-link" @click="selectParameter(102, 2)" title="Show salinity in chart and map">{{ showDigits(salinity, 1) }}</a> <small>PSU</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Salinity</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="co2 !== 0">
              <a href="#" class="parameter-link" @click="selectParameter(102, 6)" title="Show carbon dioxide in chart and map">{{ showDigits(co2, 1) }}</a> <small>ppm</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Carbon dioxide (CO<sub>2</sub>)</div>
          </div>
        </div>
        <div class="col">
          <div class="parameter-box">
            <h4 v-if="o2 !== 0">
              <a href="#" class="parameter-link" @click="selectParameter(102, 4)" title="Show oxygen in chart and map">{{ showDigits(o2, 1) }}</a> <small>&#xb5;M</small>
            </h4>
            <h4 v-else class="text-muted"><small>n/a</small></h4>
            <div class="parameter-name">Oxygen (O<sub>2</sub>)</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'

export default {
  name: 'ShipCitizenScienceStatusWidget',
  mixins: [
    Helpers
  ],
  data: function () {
    return {}
  },
  props: ['platformId'],
  methods: {
    ...mapMutations(['select_parameter']),
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    selectParameter: function (entityId, parameterId) {
      this.select_parameter([this.platformId, entityId, parameterId])
    }
  },
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate']),
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    course_over_ground () {
      const update = this.currentUpdate(this.platformId, 1, 21)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    speed_over_ground () {
      const update = this.currentUpdate(this.platformId, 1, 20)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    water_temperature () {
      const update = this.currentUpdate(this.platformId, 102, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    salinity () {
      const update = this.currentUpdate(this.platformId, 102, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    conductivity () {
      const update = this.currentUpdate(this.platformId, 102, 3)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    co2 () {
      const update = this.currentUpdate(this.platformId, 102, 6)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    h2o () {
      const update = this.currentUpdate(this.platformId, 102, 15)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    o2 () {
      const update = this.currentUpdate(this.platformId, 102, 4)
      return (update.length !== 0) ? Number(update[1]) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.parameter-box {
  padding: 10px 10px 5px 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.parameter-link {
  color: #212529;
  text-decoration: none;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}
.dashboard-group-header {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  font-weight: bold;
}
.dashboard-group-header-hr {
  margin-block-end: 0;
}
</style>
